import { Anchor, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";

// Clickable trip reference → trip detail page. Accepts a string id or a
// populated trip object ({ _id }). Shows the short id; "—" when absent.
export function TripLink({
  trip,
}: {
  trip?: string | { _id?: string; tripId?: string } | null;
}) {
  const navigate = useNavigate();
  const id =
    typeof trip === "string" ? trip : trip?._id ?? undefined;
  const label =
    (typeof trip === "object" && trip?.tripId) || (id ? id.slice(-8) : null);

  if (!id) {
    return (
      <Text size="sm" c="dimmed" span>
        —
      </Text>
    );
  }
  return (
    <Anchor
      size="sm"
      ff="monospace"
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/trips/${id}`);
      }}
    >
      {label}
    </Anchor>
  );
}
